// extracted by mini-css-extract-plugin
module.exports = {"popiaNotice":"popia-notice_popiaNotice__2q1XN","popiaLink":"popia-notice_popiaLink__qM4d8"};